import {consultantDictionary, DialogSeen} from '../../../../../controls/agyle/clinitian';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {ambulanceCodes} from '../../../../../store/reducers/dicts';
import moment from 'moment';
import keyPerformanceIndicator from '../../../../../util/timeMarker';
import {getConfig} from '../../../../../util/configUtil';

const AmbulanceHandoverForm = (props) => {
    const {t} = useTranslation();

    // Selectors
    const ambulance = useSelector(ambulanceCodes);

    // Configs
    const consultantComponentEnabled = getConfig('consultantComponentEnabled', false);

    const handleChanges = (value) => {
        const dataToSave = [
            {name: 'ambulanceHandover', value: value},
        ];

        if (value.when) {
            keyPerformanceIndicator(
                dataToSave,
                props.patient,
                ['firstInitialAssessment'],
                {
                    when: value.when,
                    who: value.who,
                },
            );
        }
        props.onChange(dataToSave);
    };

    return (
        <DialogSeen
            patient={props.patient}
            disabled={!ambulance?.includes(props.patient?.admission?.arrivalModeCode)}
            disableOpen={!ambulance?.includes(props.patient?.admission?.arrivalModeCode)}
            arrivalMode={ambulance}
            size="large"
            disableSave={props.disableSave}
            ambulanceHandover={!consultantComponentEnabled}
            allowedConsultants={consultantDictionary.ambulanceHandover}
            open={props.open}
            onClose={props.onClose}
            triageNotOpenAgain
            patientType={props.patientType}
            label={t('Ambulance Handover')}
            value={props.patient?.ambulanceHandover || {who: null, when: moment()}}
            onChange={handleChanges}
            refresh
        />
    );
};

export default AmbulanceHandoverForm;